import { display } from "html2canvas/dist/types/css/property-descriptors/display"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
  const { colors: color } = useContextState()
  return ({
    card: {
      width: '100%',
      overflowX: 'unset',
      minHeight: '300px',
      height: '100%',
      padding: '20px',
      borderRadius: '12px',
      boxShadow: `0 0 4px 0px ${color.color13}`,
      position: 'relative',
    },
    headerInputs: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px',
    },
    titleHeaders: {
      lineHeight: '1rem',
      color: color.color9,
      fontSize: '1.4rem',
      my: '5px',
      fontWeight: '500'
    },
    dateFooter: {
      fontSize: '10px',
      color: color.color9,
      mb: '1rem',
      '& span': {
        color: color.color13,
      },
    },
    filterContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '20px',
    },
    cardTotals: {
      marginTop: '10px',
      marginBottom: '15px',
      padding: '10px 15px',
      maxWidth: '50%',
      borderRadius: '8px',
    },
    tabsContainer: {
      position: 'relative',
      marginBottom: '-3px',
      width: '100%',
      '& .MuiTabs-root': {
        backgroundImage: `linear-gradient(to right, ${color.contrastEndpoint}, ${color.primaryEndpoint}, ${color.secondaryEndpoint})`,
        minHeight: '47px',
        height: '47px',
        position: 'relative',
        borderRadius: '8px 8px 0 0',
        overflow: 'hidden',
        width: '100%',
      },
      '& .MuiTab-root': {
        fontWeight: '600',
        backgroundColor: 'transparent',
        transition: 'background-color 0.3s ease',
        position: 'relative',
        zIndex: 2,
        minHeight: '47px',
        height: '47px',
        '&.Mui-selected': {
          borderRadius: '8px 8px 0 0',
          color: color.color5,
        },
        '&:not(.Mui-selected)': {
          backgroundColor: color.color5,
          color: color.color13,
        },
      },
      '& .MuiTabs-indicator': {
        display: 'none',
      },
    },
    containerCards: {
      display: 'flex',
      width: '100%',
      gap: '20px',
      flexWrap: 'wrap',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      maxHeight: 'fit-content',
    },
    refresh: {
      background: color.orangeMedium,
      color: color.color5,
      borderRadius: '5px',
      '&:hover': {
        background: `${color.orangeMedium}ee`,
      },
      '& .MuiSvgIcon-root': {
        fontSize: '2.2rem',
      }
    },
  })
} 

export { useStyles }